export default "//static.tradera.net/touchweb/static/output/images/category-accessories.19455a14.svg";